import React, { useMemo, useState } from "react";

export default function ReportFormModal({
  open,
  onClose,
  onGenerate,
  initialData,
  loading,
}) {
  const [form, setForm] = useState(initialData);

  React.useEffect(() => {
    if (open) {
      setForm({
        ...initialData,
        includeSignatureStamp: false,
      });
    }
  }, [open, initialData]);

  const update = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const disabled = useMemo(() => {
    return (
      !form.patientName ||
      !form.studyCode ||
      !form.findings ||
      !form.conclusion
    );
  }, [form]);

  if (!open) return null;

  return (
    <div className="sl-modalBackdrop" onClick={onClose}>
      <div
        className="sl-modal sl-reportModal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sl-modalTitle">Generar reporte radiológico</div>

        <div className="sl-reportGrid">
          <label>
            <span>Nombre</span>
            <input
              value={form.patientName || ""}
              onChange={(e) => update("patientName", e.target.value)}
            />
          </label>

          <label>
            <span>DUI</span>
            <input
              value={form.documentNumber || ""}
              onChange={(e) => update("documentNumber", e.target.value)}
            />
          </label>

          <label>
            <span>Fecha</span>
            <input
              value={form.reportDate || ""}
              onChange={(e) => update("reportDate", e.target.value)}
              placeholder="dd/mm/yyyy"
            />
          </label>

          <label>
            <span>Estudio</span>
            <input
              value={form.studyCode || ""}
              onChange={(e) => update("studyCode", e.target.value)}
            />
          </label>
        </div>

        <label className="sl-reportBlock">
          <span>Indicación</span>
          <textarea
            rows={3}
            value={form.indication || ""}
            onChange={(e) => update("indication", e.target.value)}
          />
        </label>

        <label className="sl-reportBlock">
          <span>Técnica</span>
          <textarea
            rows={4}
            value={form.technique || ""}
            onChange={(e) => update("technique", e.target.value)}
          />
        </label>

        <label className="sl-reportBlock">
          <span>Hallazgos</span>
          <textarea
            rows={10}
            value={form.findings || ""}
            onChange={(e) => update("findings", e.target.value)}
          />
        </label>

        <label className="sl-reportBlock">
          <span>Conclusión</span>
          <textarea
            rows={5}
            value={form.conclusion || ""}
            onChange={(e) => update("conclusion", e.target.value)}
          />
        </label>

        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginTop: "14px",
          }}
        >
          <input
            type="checkbox"
            checked={!!form.includeSignatureStamp}
            onChange={(e) =>
              update("includeSignatureStamp", e.target.checked)
            }
          />
          <span>Incluir firma y sello digital</span>
        </label>

        <div className="sl-modalActions">
          <button
            className="sl-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            className="sl-btn sl-btnPrimary"
            onClick={() => onGenerate(form)}
            disabled={disabled || loading}
          >
            {loading ? "Generando..." : "Generar y guardar PDF"}
          </button>
        </div>
      </div>
    </div>
  );
}
